import React, { useState } from 'react';
import Has from '../../../auth/Has';
import { CAN_MODIFY_ENTITY_GROUP, CAN_READ_ENTITY_GROUP } from '../../../auth/permissions';
import { SalvButton, SalvTab, SalvTabList, SalvTabPanel, SalvTabs, Size } from '@salvapp/ui-components';
import SegmentTable from './SegmentTable';
import { InternalApiEntityType } from '../../../api-internal';
import SegmentEditor from './SegmentEditor';
import './Segments.scss';
import SalvPage from '../../../common/SalvPage';
import { getConfigurationUrl } from '../../../navigation/helper';
import { SearchParamKeys } from '../../../common/searchParamKeys';
import { useSearchParams } from 'react-router-dom';
import ExternalLink from '../../../common/ExternalLink';
import { ConfigurationProduct } from '../../../settings/configuration/Configuration';

const Segments = () => {
  const [showEditor, setShowEditor] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const entityType =
    (searchParams.get(SearchParamKeys.entityType) as InternalApiEntityType) || InternalApiEntityType.PERSON;
  return (
    <SalvPage
      title={'Segments'}
      className='entity-groups'
      breadcrumb={{
        title: 'Configuration',
        to: getConfigurationUrl(ConfigurationProduct.GENERAL),
      }}
      actions={<SalvButton label='New Segment' size={Size.SMALL} onClick={() => setShowEditor(true)} />}
    >
      <div className='text-s m-b-16' style={{ width: '700px', color: 'var(--text-medium)' }}>
        Define Person and Transaction Segments that can be used in Screening and Monitoring configurations. Read more
        about Segments <ExternalLink title={'here'} link={'https://help.salv.com/en/articles/204210-segments'} />.
      </div>
      <Has allPermissions={CAN_READ_ENTITY_GROUP}>
        <SalvTabs value={entityType} onChange={(value) => setSearchParams({ [SearchParamKeys.entityType]: value })}>
          <SalvTabList>
            <SalvTab value={InternalApiEntityType.PERSON} title='Person' />
            <SalvTab value={InternalApiEntityType.TRANSACTION} title='Transaction' />
          </SalvTabList>
          <SalvTabPanel value={InternalApiEntityType.PERSON}>
            <SegmentTable type={InternalApiEntityType.PERSON} />
          </SalvTabPanel>
          <SalvTabPanel value={InternalApiEntityType.TRANSACTION}>
            <SegmentTable type={InternalApiEntityType.TRANSACTION} />
          </SalvTabPanel>
        </SalvTabs>
        {showEditor && (
          <Has allPermissions={CAN_MODIFY_ENTITY_GROUP}>
            <SegmentEditor defaultType={entityType} onClose={() => setShowEditor(false)} />
          </Has>
        )}
      </Has>
    </SalvPage>
  );
};

export default Segments;
